export let QualificationFieldsJSON = {
    "1001-customSelect": {
        elementid: 1001,
        elementtype: "customSelect",
        "display-fieldlabel": "Category",
        "display-required": 1,
        "database-label": "doctor_category",
        "data-datasource": "customvalues",
        "data-customvalue": "GP#Invasive#Non_Invasive#Super_Speciality",
        "display-placeholder": "Select",
        "display-labelposition": "top",
        "parent-key": "",
    },
    "1002-textfield": {
        elementid: 1002,
        elementtype: "textfield",
        "display-fieldlabel": "Qualification",
        "display-required": 1,
        "database-label": "qualification",
        "display-placeholder": "Enter",
        "validation-maxlength": "2000",
        "validation-minlength": "0",
        "display-labelposition": "top",
        "parent-key": "",
    },
    "1003-multiselect": {
        elementid: 1003,
        elementtype: "multiselect",
        "display-fieldlabel": "AG",
        "display-required": 1,
        "database-label": "organisation_id",
        "data-datasource": "customvalues",
        "data-customvalue": "",
        "display-placeholder": "Select",
        "display-labelposition": "top",
        "parent-key": "",
    },
    "1004-columns": {
        elementid: 1004,
        elementtype: "columns",
        "display-fieldlabel": "Columns",
        "display-noofcolumns": "2",
    },
    "1005-columns": {
        elementid: 1005,
        elementtype: "columns",
        "display-fieldlabel": "Columns",
        "display-noofcolumns": "2",
    },
};